module.exports = __webpack_public_path__ + "static/media/03-banner-01-santa-fe@2x.fe0ac745.jpg";